<div class="signup-container">
    <div id="snackbar"></div>
    <re-captcha size="invisible" #captchaRef="reCaptcha" (resolved)="submitCaptcha($event)"></re-captcha>
    <!-- <toaster-container [toasterconfig]="config"></toaster-container> -->
    
    <!-- Left Panel with Full Image Background -->
    <div class="signup-left-panel"></div>

    <!-- Right Panel with Form -->
    <div class="signup-right-panel" *ngIf="signupForm">

        <div class="signup-form-wrapper">
            <h1 class="signup-title">{{'Sign Up' | translate}}</h1>

            <div class="form-div">


                <div class='form-group'>
                    <label class="form-label">{{'Email ID' | translate}}</label>
                    <input autocomplete="off" type="email" class="blue-inputs" placeholder="Enter Email"
                        name="SignUpObject.email" [(ngModel)]="SignUpObject.email">
                </div>

                <div class="form-row">
                    <div class='form-group form-group-half'>
                        <label class="form-label">{{'Full Name' | translate}}</label>
                        <input autocomplete="off" type="text" class="blue-inputs" placeholder="Enter Name"
                            name="SignUpObject.fullName" [(ngModel)]="SignUpObject.fullName"
                            (keypress)="blockSpecialChar($event)">
                    </div>

                    <div class='form-group form-group-half'>
                        <label class="form-label">{{'User Name' | translate}}</label>
                        <input autocomplete="off" maxlength="20" type="text" class="blue-inputs"
                            placeholder="Enter Username" name="SignUpObject.username"
                            [(ngModel)]="SignUpObject.username">
                    </div>
                </div>

                <div class='form-group'>
                    <label class="form-label">{{'Affiliate Code (optional)' | translate}}</label>
                    <input autocomplete="off" type="text" class="blue-inputs"
                        placeholder="Enter Code" name="SignUpObject.referralCode"
                        [(ngModel)]="SignUpObject.referralCode">
                </div>

                <div class="form-row">
                    <div class='form-group form-group-half'>
                        <label class="form-label">{{'Country of Residence' | translate}}</label>
                        <select class="form-control blue-inputs" (change)="oncountrychange($event)">
                            <option value="">Select Country</option>
                            <option *ngFor="let country of countriesList" value='{{country.code}} {{country.name}}'>{{country.name}}</option>
                        </select>
                    </div>

                    <div class='form-group form-group-half'>
                        <label class="form-label">{{'Mobile Number' | translate}}</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text codearea" *ngIf="countryCode">{{countryCode}}</span>
                            </div>
                            <input type="number" placeholder="Enter Number" class="form-control blue-inputs" name="SignUpObject.mobile" [(ngModel)]="SignUpObject.mobile">
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class='form-group pwd-rel form-group-half'>
                        <label class="form-label">{{'Password' | translate}}</label>
                        <input type="password" #passwordField class="blue-inputs" placeholder="Enter Password"
                            name="SignUpObject.password" [(ngModel)]="SignUpObject.password">
                        <span *ngIf="!isShow" class="toggle-password toggle-signup fa fa-eye-slash"
                            (click)="showPassword()"></span>
                        <span *ngIf="isShow" class="fa fa-eye toggle-password toggle-signup"
                            (click)="hidePassword()"></span>
                    </div>

                    <div class='form-group pwd-rel form-group-half'>
                        <label class="form-label">{{'Confirm Password' | translate}}</label>
                        <input type="password" class="blue-inputs" #confirmPasswordField
                            placeholder="Enter Password" name="SignUpObject.cPassword"
                            [(ngModel)]="SignUpObject.cPassword" (keydown)="signUpWithEnter($event)">
                        <span *ngIf="!isConfirm" class="toggle-password toggle-signup fa fa-eye-slash"
                            (click)="showPassword('confirm')"></span>
                        <span *ngIf="isConfirm" class="fa fa-eye toggle-password toggle-signup"
                            (click)="hidePassword('confirm')"></span>
                    </div>
                </div>

                <div class='form-group'>
                    <p class="terms-checkbox-row">
                        <input type="checkbox" id="TermsCheck" />
                        <label for="TermsCheck" class="terms-text">
                            <span>{{'I confirm that I have read, accepted and agreed to all' | translate}}</span>
                            <a class="links-signup piptle-links no-underline" target="_blank" [(href)]=documentUrl>{{'Terms & Conditions' | translate}}</a>
                            <span>&</span>
                            <a class="links-signup no-underline piptle-links" target="_blank" [(href)]=privacyPolicy>{{'Privacy Policy' | translate}}</a>
                            <span>{{'and that I am of legal age' | translate}}</span>
                        </label>
                    </p>
                </div>

                <div *ngIf="signUpLoaderShow" class="loader">
                    <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <g transform="rotate(208.756 50 50)">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                                values="360 50 50;0 50 50" keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5"
                                calcMode="spline"></animateTransform>
                            <path fill="#85ffbd"
                                d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                            </path>
                            <path fill="#316598"
                                d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                            </path>
                            <path fill="#a4bcc2"
                                d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                            </path>
                        </g>
                    </svg>
                </div>
                <div class="form-button" *ngIf="actionBtnShow">
                    <button class="blue-submit" (click)="signUp()">{{'Sign Up' | translate}}</button>
                </div>

                <div class="signin-link-wrapper">
                    <p class="signin-link-text">
                        {{'Already have an account?' | translate}} 
                        <a class="signin-link" (click)="routeToLogin()">{{'Sign In' | translate}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Resend Verification Panel -->
    <div class="signup-right-panel" *ngIf="resendEmail">



        <div class="signup-form-wrapper">
            <div class="form-div">

                <p class="verify-text">{{'A verification link has been sent to' | translate}}
                    <strong class="email-strong">{{SignUpObject.email}}</strong>
                </p>

                <p class="verify-text">{{'If you did not receive our email, click below to receive verification link.' |
                    translate}}</p>
                <div *ngIf="resendEmailLoader" class="loader">
                    <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <g transform="rotate(208.756 50 50)">
                            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite"
                                values="360 50 50;0 50 50" keyTimes="0;1" dur="2.3s" keySplines="0.5 0.5 0.5 0.5"
                                calcMode="spline"></animateTransform>
                            <path fill="#85ffbd"
                                d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                            </path>
                            <path fill="#316598"
                                d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                            </path>
                            <path fill="#a4bcc2"
                                d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                            </path>
                        </g>
                    </svg>
                </div>
                <div class="form-button" *ngIf="actionBtnShow">
                    <button class="blue-submit" (click)="resendVerificationCode()">{{'Resend Verification Link' | translate}}</button>
                </div>
                <div class="signin-link-wrapper">
                    <p class="signin-link-text">
                        {{'Already have an account?' | translate}} 
                        <a class="signin-link" (click)="routeToLogin()">{{'Sign In' | translate}}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>